<app-navbar-primary />

<main class="bg-body-secondary">
  <div class="d-flex justify-content-center align-items-center h-100">
    <div class="card overflow-auto" style="width: 42rem; max-width: 95vw; height: 80vh">
      <div class="card-body">
        <button class="btn p-0 mb-3" routerLink="/">
          <img src="/assets/icons/arrow_left_short.svg" alt="" />
          <span class="text-body-secondary">Volver</span>
        </button>

        <h4>Información financiera</h4>

        <div class="d-flex flex-column mt-4">
          @if (loading) {
            <div class="text-center py-3">
              <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            </div>
          } @else if (error) {
            <div class="text-body-secondary py-2">
              No se pudo cargar la información financiera. Intenta más tarde.
            </div>
          }
          @for (section of sections; track $index) {
            <div>
              <button
                class="btn btn-outline-primary mt-2 mb-1"
                type="button"
                data-bs-toggle="collapse"
                [attr.data-bs-target]="'#collapse-section-' + $index"
                aria-expanded="false"
                [attr.aria-controls]="'collapse-section-' + $index"
                (click)="buttonCollapsed[$index] = !buttonCollapsed[$index]"
              >
                <i
                  class="bi"
                  [class]="
                    buttonCollapsed[$index] ? 'bi-chevron-down' : 'bi-chevron-up'
                  "
                ></i>
                {{ section.title }}
              </button>
            </div>

            <div class="collapse" [id]="'collapse-section-' + $index">
              @for (group of section.groups; track $index) {
                <h6 class="text-body-secondary mt-3 mb-2">{{ group.title }}</h6>

                <div class="list-group">
                  @for (file of group.links; track file.url) {
                    <a
                      class="list-group-item list-group-item-action"
                      [href]="file.url"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {{ file.name }}
                    </a>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</main>

<app-footer-primary />